import { defineMessages } from 'react-intl';

export const paymentAllocationMessages = defineMessages({
    allocations: {
        id: 'allocations',
        defaultMessage: 'Allocations',
    },
    allocation: {
        id: 'allocation',
        defaultMessage: 'Allocation',
    },
    paymentAllocations: {
        id: 'payment-allocations',
        defaultMessage: 'Payment allocations',
    },
    deletePaymentAllocation: {
        id: 'delete-payment-allocation',
        defaultMessage: 'Delete payment allocation',
    },
    deletePaymentAllocationSuccess: {
        id: 'delete-payment-allocation-success',
        defaultMessage: 'Payment allocation deleted',
    },
    deletePaymentAllocationSuccessDescription: {
        id: 'delete-payment-allocation-success-description',
        defaultMessage: 'The payment allocation has been successfully deleted.',
    },
    confirmDeletePaymentAllocation: {
        id: 'confirm-delete-payment-allocation',
        defaultMessage: 'Are you sure you want to delete this payment allocation? This action cannot be undone.',
    },
    deletePaymentAllocationSubtitle: {
        id: 'delete-payment-allocation-subtitle',
        defaultMessage: 'Permanently delete payment allocation',
    },
    createPaymentAllocationSuccess: {
        id: 'create-payment-allocation-success',
        defaultMessage: 'Payment allocation created',
    },
    createPaymentAllocationSuccessDescription: {
        id: 'create-payment-allocation-success-description',
        defaultMessage: 'Payment allocation has been successfully created.',
    },
    addPaymentAllocationSubtitle: {
        id: 'add-payment-allocation-subtitle',
        defaultMessage: 'Create a new payment allocation',
    },
    exceedingAllocationAmountError: {
        id: 'custom-error:payment_remaining_amount_exceeded',
        defaultMessage: 'Trying to allocate more amount than the remaining one of the payment!',
    },
    remainingAmountExceedsError: {
        id: 'custom-error:financial_document_remaining_amount_exceeded',
        defaultMessage: 'Trying to allocate more amount than the remaining one of the financial document!',
    },
});
